import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      title: 'Create Your Profile',
      description: 'Share your authentic self with photos, interests, and what you\'re looking for.'
    },
    {
      number: 2,
      title: 'Get Matched',
      description: 'Our smart algorithm suggests compatible matches based on your preferences.'
    },
    {
      number: 3,
      title: 'Start Connecting',
      description: 'Message securely and build genuine connections at your own pace.'
    }
  ];

  return (
    <section className="py-24 px-6 bg-blush/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-4 text-charcoal">
            How It Works
          </h2>
          <p className="text-lg text-charcoal/70">
            Finding your match has never been simpler
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step) => (
            <div key={step.number} className="text-center">
              <div className="w-16 h-16 bg-rose text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
              <p className="text-charcoal/70">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;